import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import './aboutTeam.scss';
import { PersonalComputer } from 'src/assets';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const AboutTeam = () => {
  const { t } = useTranslation();

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="about-team">
      <div className={`about-team-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="about-team-title">
          <supertitle>{t('title:aboutUs')}</supertitle>
          <h1>
            <blue-underline>{t('aboutTeam:about')}</blue-underline> {t('aboutTeam:our')}{' '}
            <blue-text>{t('aboutTeam:team')}</blue-text>
          </h1>
        </div>

        <div className="about-team-section">
          <div className="about-team-section-row">
            <div className="about-team-item text-right">
              <h3>{t('aboutTeam:analysisTitle')}</h3>
              <text>{t('aboutTeam:analysisSub')}</text>
            </div>
            <div className="about-team-item text-left">
              <h3>{t('aboutTeam:techTitle')}</h3>
              <text>{t('aboutTeam:techSub')}</text>
            </div>
          </div>
          <div className="about-team-section-row" style={{ paddingBottom: 0 }}>
            <div className="about-team-item text-right">
              <h3>{t('aboutTeam:educationTitle')}</h3>
              <text>{t('aboutTeam:educationSub')}</text>
            </div>
            <div className="about-team-item text-left">
              <h3>{t('aboutTeam:marketTitle')}</h3>
              <text>{t('aboutTeam:marketSub')}</text>
            </div>
          </div>
          <img src={PersonalComputer} alt={PersonalComputer} className="about-team-item-image" />
        </div>
      </div>
    </div>
  );
};
